var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGarbage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.935 473.935",
    style: {
      enableBackground: "new 0 0 473.935 473.935"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E8E8DF"
    },
    cx: 236.967,
    cy: 236.967,
    r: 236.967
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B342D"
    },
    d: "M361.535,319.863c19.704,86.461-48.321,97.926-120.396,106.162 c-76.613,8.76-159.786-30.642-142.274-106.162c17.029-73.444,80.063-191.306,131.337-191.306S338.041,216.724,361.535,319.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B342D"
    },
    d: "M259.377,128.557c0,7.225,19.397,57.998,7.753,57.998h-74.211 c-11.644,0,15.547-50.772,15.547-57.998l-19.323-65.953c0-7.222,9.01-12.894,35.109-16.344 c41.272-5.448,57.949,4.763,57.949,11.989L259.377,128.557z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#453F38"
    },
    d: "M224.253,46.26c-26.099,3.45-35.109,9.122-35.109,16.344l19.323,65.953 c0,1.306-0.898,4.049-2.286,7.648c-45.369,27.222-92.875,121.387-107.314,183.658C81.354,395.383,164.53,434.784,241.14,426.025 C313.214,417.789,224.253,46.26,224.253,46.26z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#737373"
    },
    d: "M276.088,136.8c0,3.79-2.829,6.862-6.324,6.862c0,0-36.052,4.09-47.248,3.386 c-11.188-0.7-17.665-3.386-17.665-3.386c-3.491,0-6.316-3.072-6.316-6.862l0,0c0-3.79,2.829-6.862,6.316-6.862 c0,0,0.079,0.786,18.469,3.39s46.443-3.39,46.443-3.39C273.259,129.937,276.088,133.009,276.088,136.8L276.088,136.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#737373"
    },
    d: "M278.961,162.379c-1.478-12.082-9.845-28.187-9.845-28.187c-0.674-3.727-4.239-6.204-7.966-5.534 s-6.211,4.243-5.538,7.97c0,0,8.703,7.222,9.684,27.334c0.98,20.116-3.252,20.337-3.252,20.337 c0.681,3.731,7.719,6.208,11.446,5.534c3.734-0.674,7.948-2.503,7.274-6.234C280.765,183.598,280.425,174.461,278.961,162.379z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B342D"
    },
    d: "M188.683,399.571c-15.727,10.14-48.49-11.809-58.626-27.54 c-10.144-15.742-15.656-49.725,0.086-59.861C145.881,302.033,204.425,389.434,188.683,399.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E1B18"
    },
    d: "M272.327,56.295c0.483,4.471-15.626,9.878-35.97,12.075c-20.352,2.2-37.235,0.352-37.721-4.123 c-0.479-4.468,16.902-13.994,37.253-16.191C256.226,45.859,271.837,51.824,272.327,56.295z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarbage);
export default __webpack_public_path__ + "static/media/garbage.520ba2b953656a2727cfe3871e255aeb.svg";
export { ForwardRef as ReactComponent };